import { useTranslation } from "react-i18next";
import { Box, Skeleton, Typography } from "@mui/material";

import { formatLocalizedTimeAgo } from "../../../../utils/formatDate";
import { formatNumberWithK } from "../../../../utils/formatters/numberFormatter";

import { ExpiryIcon } from "../../assets/icons/go-hire-icons";
import { ServiceRequestUnitEnum } from "../../enum/service.enum";

export const SummaryHeader = ({
  amount,
  currency,
  type,
  expiryDate,
  unit,
}: {
  amount: number;
  currency: string;
  type: string;
  expiryDate?: string;
  unit?: ServiceRequestUnitEnum;
}) => {
  const { t, i18n } = useTranslation("goService", { keyPrefix: "components" });
  const { t: tCurrency } = useTranslation("goService", { keyPrefix: "serviceCurrency" });
  const { t: tServiceType } = useTranslation("goService", { keyPrefix: "serviceType" });

  const isRTL = i18n.language === "ar";

  return (
    <Box sx={styles.headerContent}>
      <Box sx={styles.priceContainer}>
        <Typography sx={styles.price}>
          {isRTL
            ? `${formatNumberWithK(amount / 100, i18n.language)} ${tCurrency(currency)}`
            : `${tCurrency(currency)}${formatNumberWithK(amount / 100, i18n.language)}`}
        </Typography>
        <Typography sx={styles.type}>
          {unit ? t(unit, { amount: `${tCurrency(currency)}${formatNumberWithK(amount / 100, i18n.language)}` }) : ""}
        </Typography>
      </Box>
      {expiryDate && (
        <Typography sx={styles.expiresIn}>
          <ExpiryIcon /> {`${t("expiresIn")} ${formatLocalizedTimeAgo(expiryDate, i18n.language)}`}
        </Typography>
      )}
    </Box>
  );
};

export const SummaryHeaderLoader = () => {
  return (
    <Box sx={styles.headerContent}>
      <Skeleton variant="rounded" width={200} height={40} />
      <Skeleton variant="rounded" width={150} height={24} />
    </Box>
  );
};

const styles = {
  headerContent: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  priceContainer: {
    display: "flex",
    alignItems: "flex-end",
  },
  price: {
    color: "var(--Gray-900, #1D2026)",
    fontFamily: "Montserrat",
    fontSize: "28px",
    fontStyle: "normal",
    fontWeight: 800,
    lineHeight: "normal",
  },
  type: {
    color: "var(--Gray-900, #1D2026)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "25px",
  },
  expiresIn: {
    color: "var(--Error-500, #E34444)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
} as const;
